/* eslint-disable no-console */
import {
  Component,
  OnInit,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITestInfoValue, ITimePickerValue } from '@nrwl/breadcrumb-actions-timepicker';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(Highcharts);
import { CollectorApiService, ControllerApiService } from '@nrwl/test-setup';
import {
  HelpersService,
  LmapService,
  DevicesService,
  DataEnrichmentService
} from '@nrwl/common-lib';
import { IWidgetConfig } from './types';
import { TWAMP_QUERY_CONFIG } from './twamp.reports.config';
import { SummaryChartBaseComponent } from '../twamp/summary-chart-base.component';
import { InitialData } from 'libs/common-lib/src/lib/services/highcharts/types';
import { TwampResultsService } from '../../../../../../test-running/src/lib/test-running/results/twamp/service/twamp-results.service';
import { INavigationItem } from '@nrwl/navigation-abstract';
import { TestListTransformationService } from 'libs/common-lib/src/lib/providers/fusion.transform.provider/service/test-list.transformation.service';

@Component({
  selector: 'nrwl-twamp',
  templateUrl: './twamp.reports.component.html',
  styleUrls: ['./twamp.reports.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TwampReportsComponent
  extends SummaryChartBaseComponent
  implements OnInit, OnChanges, OnDestroy
{
  reportName: string;
  reportStartTime: string;
  scheduleId: number;
  runId: number;
  testName: string;
  testData: string;
  reportRows;
  daysToReport;
  slaArray;
  pmInterval;
  testPoint;
  codecType;
  testType;
  flowConfig;
  resultEndDate;

  log = false;
  loading: boolean;
  logoUrl = 'images/viavi-logo-purple.png';
  dataSource: BehaviorSubject<any>;
  requestInfo = {};
  source: string;
  testInfoValue: ITestInfoValue = {
    isVisible: true,
    isActionHidden: true
  };
  timePickerValue: ITimePickerValue = {
    isVisible: false,
    isFixed: false
  };
  layeredSource = [];
  _testName: string;
  clientHeight: number;
  breadCrumbValues: Array<INavigationItem> = [];

  includeSlaInReport = false;
  slaThresholdBoolean = false;
  rptSamplesNeeded = 0;
  trendingMsg = '';
  widgetConfig: IWidgetConfig[] = [];
  lastPMSamplePostDate = null;
  reportProgressContainerVisible: boolean;
  rptLastSampleDate: string;
  rptRequestRetries: number;
  rptSeqNumsProcessed = [];
  rptSamplesReceived = 0;
  rptRequestCtr = 0;
  rptBatchSize = 50;
  chartValue = {
    target: 90,
    CIR: 100
  };
  rptStartRequestTime = new Date();
  flowResults = [];
  rptSampleStartTime: any;
  rptSampleEndTime: Date;
  rptTotalTime: number;
  reportProgress: any;
  reportMsg: string;
  rptBatchSizeTimeout: number;
  charts: any;
  thisFlow: any;
  granularityInterval = 60000;
  rptMaxRequestRetries = 3;
  chartConfigs: IWidgetConfig[] = [];
  reportFlows: string;
  pageHeight: string;
  chartDataList: InitialData[] = [];
  chartDataArray = [];
  reportStart: any;
  reportEnd: any;
  reportArray = [];
  changeDetectorRef: ChangeDetectorRef;
  statusLabel: any;
  progressPercentage = 0;
  reports = [];
  type: any;
  twampBatchSize = 50;
  y1731BatchSize = 150;
  testTypeName: string;
  isMosEnabled = false;
  flowSession = [];
  serverConfig: any;
  reportmessage: any;
  @ViewChild('printSection') printSection!: ElementRef;
  private readonly unsubscribe: Subject<void> = new Subject();
  private readonly _unsubscribe: Subject<void> = new Subject();
  constructor(
    private collectorApiService: CollectorApiService,
    private controllerApiService: ControllerApiService,
    private activatedRoute: ActivatedRoute,
    changeDetectorRef: ChangeDetectorRef,
    private readonly helperService: HelpersService,
    readonly deviceService: DevicesService,
    private lmapService: LmapService,
    private dataEnrichmentService: DataEnrichmentService,
    private twampResultsService: TwampResultsService,
    private fusionTransformationService: TestListTransformationService
  ) {
    super();
    this.changeDetectorRef = changeDetectorRef;
    this.loading = false;
  }

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.loading = true;
    this._handleQueryParams();
    this.getServerConfig();
    this.getTrendingData(this.daysToReport);
  }

  getServerConfig(): void {
    this.controllerApiService.getServerConfig().subscribe(response => {
      this.serverConfig = response.data;
      const serverConfig = response.data['reports'];
      if (serverConfig && serverConfig.logo && serverConfig.logo.url) {
        this.logoUrl = serverConfig.logo.url;
      }
      if (serverConfig && serverConfig.message) {
        this.reportmessage = serverConfig.message;
      }
    });
  }

  getTrendingData(days: number): void {
    const maxReports = days * (24 * (60 / this.pmInterval));
    if (this.testType) {
      this.testTypeName = this.fusionTransformationService.getTestType(this.testType);
    }

    const opt = {
      scheduleId: this.scheduleId,
      reportType: 'pm',
      runid: this.runId
    };

    this.collectorApiService
      .getReportCount(opt)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (this.log === true) {
            console.log('RT Report Count: response: + ' + JSON.stringify(response));
          }

          const errorMsg = this.helperService.getResponseErrorMsg(response);

          if (errorMsg == null) {
            if (response.data) {
              if (response.data.results) {
                this.rptSamplesNeeded = response.data.results;
                this.trendingMsg =
                  'Retrieving ' +
                  this.helperService.addCommas(this.rptSamplesNeeded.toString()) +
                  ' samples';

                this.rptSamplesNeeded = Math.min(response.data.results, maxReports);
              }
            } else {
              console.log('ERROR: response.data does not exist in RT Report Count response');
            }
          } else {
            console.log('ERROR: RT Report Count Failed because : ' + errorMsg);
          }
          this.startReportCreation(days);
        },
        () => {
          this.trendingMsg = 'No data found';
        }
      );
  }

  startReportCreation(days: number): void {
    if (!Array.isArray(this.reportRows)) {
      const reportArrayData = [];
      reportArrayData.push(this.reportRows);
      this.reportRows = reportArrayData;
    }
    this.rptBatchSize = !this.testType.toLowerCase().includes('twamp')
      ? this.y1731BatchSize
      : this.twampBatchSize;
    this.reportRows = this.reportRows.map(row => row.trim());
    this.trendingMsg =
      'Retrieving ' + this.helperService.addCommas(this.rptSamplesNeeded.toString()) + ' samples';
    let newDataFormatted = null;
    this.reportProgressContainerVisible = true;
    const startTimeMs = new Date(this.resultEndDate).getTime() - days * 24 * 60 * 60 * 1000;
    newDataFormatted = new Date(startTimeMs).toISOString().substring(0, 19) + '+00:00';
    if (this.log) {
      console.log(`START TIME: ${newDataFormatted}`);
    }

    this.rptLastSampleDate = newDataFormatted;
    this.rptRequestRetries = 0;
    this.getReports(this.rptLastSampleDate);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getReports(fromTime: string): void {
    this.rptBatchSize = !this.testType.toLowerCase().includes('twamp')
      ? this.y1731BatchSize
      : this.twampBatchSize;
    this.rptRequestCtr++;
    const opt = {
      scheduleId: this.scheduleId,
      reportType: 'pm',
      runid: this.runId,
      maxresults: this.rptBatchSize,
      reportFlows: this.reportRows,
      fromtime: fromTime
    };

    console.log(
      new Date().toLocaleTimeString() + ' REQUESTING REPORT BATCH: ' + this.rptRequestCtr
    );
    this.statusLabel = 'Retrieving Samples: ' + this.rptRequestCtr;

    this.collectorApiService
      .getQueryReportByFromTime(
        this.scheduleId,
        this.runId,
        'pm',
        fromTime,
        this.rptBatchSize,
        this.reportRows
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.processReportBatch(response);
        },
        error => {
          console.error('Error fetching report batch:', error);
          // Optionally, handle retries or other error logic
        }
      );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processReportBatch(response: any): void {
    if (this.log) {
      console.log(new Date().toLocaleTimeString() + ' Batch arrived');
    }

    const errorMsg = this.helperService.getResponseErrorMsg(response);

    if (errorMsg == null) {
      if (response && response.data) {
        const allRtReport = response.data;
        this.reportName = allRtReport[0]['ietf-lmap-report:report'].result[0]['schedule-name'];
        this.reportFlows = this.reportRows.toString();

        for (let i = 0; i < allRtReport.length; i++) {
          const report = this.lmapService.ltranslateLmapReportIndexToAngular(allRtReport, null, i);
          if (report?.length) {
            this.reportArray.push(...report);
          }
          if (this.rptSamplesReceived === 0) {
            this.reportStart = allRtReport[0]['ietf-lmap-report:report'].result[0].start;
          }
          this.reportEnd = allRtReport[i]['ietf-lmap-report:report'].result[0].end;
        }

        this.rptSamplesReceived += response.data.length;
        this.progressPercentage =
          this.rptSamplesNeeded > 0
            ? Math.min((this.rptSamplesReceived / this.rptSamplesNeeded) * 100, 100)
            : 100;
        this.statusLabel = `Retrieving ${
          this.rptSamplesReceived
        } samples (${this.progressPercentage.toFixed(2)}%)`;

        // Manually trigger change detection
        this.changeDetectorRef.detectChanges();

        if (this.rptSamplesReceived >= this.rptSamplesNeeded) {
          this.statusLabel = 'Retrieving Completed';
          setTimeout(() => {
            this.loading = false; // Hide the loader when done
          }, 300);
          this.chartData(this.reportArray);
        } else {
          this.rptLastSampleDate = this.lmapService.getReportPostDate(
            response,
            response.data.length - 1
          );
          this.getReports(this.rptLastSampleDate);
        }
      }
    } else {
      console.error(errorMsg);
    }
  }

  chartData(response: any[]): void {
    this.widgetConfig = TWAMP_QUERY_CONFIG.widgetConfig;
    // Initialize an array to store data for each flow
    this.chartDataArray = this.reportRows.map(flowName => {
      // Create chart configuration for each flow
      const chartConfigs = this.widgetConfig
        .map(config => {
          const updatedConfig = {
            ...config,
            title: config.title.replace('<<Flow Name>>', flowName)
          };

          // Check if any key in the response includes 'MOS' and only include the chart if true
          const mosAvailable = response.some(item =>
            Object.keys(item).some(key => key.includes('MOS'))
          );

          if (updatedConfig.title.includes('MOS') && !mosAvailable) {
            return null; // Skip the MOS chart if MOS values are not available
          }

          if (!this.isMosEnabled && mosAvailable && updatedConfig.title.includes('MOS')) {
            return null;
          }

          if (
            !this.testType.toLowerCase().includes('twamp') &&
            updatedConfig.title.includes('Frame Loss') &&
            this.isflowSLMPeriodOff(flowName)
          ) {
            return null; // Skip the frame loss chart if the condition is not met
          }

          // Update fieldName based on codecType
          if (this.codecType === 'R-factor') {
            updatedConfig.options.series.forEach(series => {
              if (series.fieldName === 'QM 2way MOS') {
                series.fieldName = 'QM 2way R-factor';
              }
            });
          }

          if (
            updatedConfig.title.includes('Frame Loss') &&
            !this.testType.toLowerCase().includes('twamp')
          ) {
            updatedConfig.options.series = updatedConfig.options.series.filter(
              series => series.showInY1731
            );
          }
          // Toggle visibility of SLA series based on slaThresholdBoolean
          updatedConfig.options.series.forEach(series => {
            if (series.fieldName === 'SLA') {
              series.visible = this.slaThresholdBoolean;
            }
          });
          const isPingSession = this.isPingSession(flowName);
          if (isPingSession) {
            updatedConfig.options.series.forEach(series => {
              if (
                [
                  'FD 1way Avg N->F',
                  'FD 1way Avg F->N',
                  'IFDV 1way Avg N->F',
                  'IFDV 1way Avg F->N'
                ].includes(series.fieldName)
              ) {
                series.visible = false;
              }
            });
          }

          return updatedConfig;
        })
        .filter(config => config !== null); // Filter out any null configurations (i.e., skipped MOS charts)
      // Process each chart configuration for the current flow
      const flowChartDataArray = chartConfigs.map((chartConfig, configIndex) => {
        const chartSeriesData = chartConfig.options.series.map(seriesConfig => ({
          title: chartConfig.title,
          chart: seriesConfig,
          data: []
        }));

        // Populate series data for the current flow
        response
          .filter(item => item['FDFr EVC ID'] === flowName) // Only process items for the current flow
          .forEach(item => {
            chartSeriesData.forEach(series => {
              let yValue = item[series.chart.fieldName];
              yValue = parseFloat(yValue);

              if (yValue !== undefined) {
                if (series.chart.fieldName === 'SLA') {
                  yValue = this.slaArray[configIndex]; // Use configIndex to align with SLA array
                } else if (
                  [
                    'FD 1way Avg N->F',
                    'FD 1way Avg F->N',
                    'FD 2way Avg',
                    'IFDV 1way Avg N->F',
                    'IFDV 1way Avg F->N',
                    'IFDV 2way Avg'
                  ].includes(series.chart.fieldName)
                ) {
                  yValue = (yValue / 1000).toFixed(3); // Format in ms
                } else {
                  yValue = parseFloat(yValue);
                }
                series.data.push({
                  x: new Date(item['Period Start Time']).getTime(),
                  y: parseFloat(yValue)
                });
              }
            });
          });

        // Enrich and return the processed data for the current chart
        return this.dataEnrichmentService.processData(chartSeriesData, this.granularityInterval);
      });

      // Return an object containing the flowName and its corresponding chart data
      return {
        flowName,
        chartData: flowChartDataArray,
        titles: chartConfigs.map(config => config.title)
      };
    });
  }

  private _handleQueryParams(): void {
    this.activatedRoute.queryParams.pipe(takeUntil(this._unsubscribe)).subscribe(queryParams => {
      this.source = queryParams.source;
      this._testName = queryParams.testName;
      this.layeredSource = queryParams.layeredSource;
      this.testType = queryParams.testType;
      this.runId = queryParams.runId;
      this.reportStartTime = queryParams.reportStartTime;
      this.scheduleId = queryParams.testId;
      this.flowConfig = JSON.parse(queryParams?.flowConfig);
      this.isMosEnabled = queryParams?.mosEnabled?.toLowerCase() === 'true';
      this.reportRows = queryParams?.reportFlows;
      this.daysToReport = queryParams?.daysToReport;
      this.pmInterval = queryParams?.pmInterval;
      this.testPoint = queryParams?.testPoint;
      this.codecType = queryParams?.codecType;
      this.slaArray = queryParams?.slaArray;
      this.resultEndDate = queryParams?.resultEndDate;
      this.requestInfo = JSON.parse(queryParams?.requestInfo);
    });
    this._handleBreadcrumbValues();
  }

  private _handleBreadcrumbValues(): void {
    const breadCrumbValues: Array<INavigationItem> = [];
    if (this.layeredSource?.length) {
      this.layeredSource.forEach(breadCrumbLabel => {
        breadCrumbValues.push({ label: breadCrumbLabel });
      });
    } else if (this.source) {
      breadCrumbValues.push({ label: this.source });
    }
    const labelValue = this._testName ? `${this._testName}` : this.testType.toLocaleUpperCase();
    breadCrumbValues.push({ label: labelValue });

    this.breadCrumbValues = breadCrumbValues;
  }

  slaThreshold(): void {
    this.includeSlaInReport = !this.includeSlaInReport;
    this.slaThresholdBoolean = this.includeSlaInReport;

    // Re-run chartData to apply the visibility changes
    this.chartData(this.reportArray); // Ensure 'this.responseData' contains the latest response data
  }

  startRequestForReportBatch(): void {
    this.rptRequestCtr++;

    // Check if we need to retry the request
    if (this.rptRequestRetries >= this.rptMaxRequestRetries) {
      console.log('Max request retries reached. Aborting.');
      return;
    }
  }

  print(): void {
    window.print();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes && changes.expertView) {
    //   this.expertView = changes.expertView.currentValue;
    // }
    if (changes && changes.runId) {
      this.runId = Number(changes.runId.currentValue);
      this.init();
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    // if (this.log) {
    console.log('DESTROY');
    // }
  }

  isPingSession(fid: string): boolean {
    const filterFlow = this.flowConfig.filter(
      item => item.flowId === fid && item.sessionType === 'Ping'
    );
    return filterFlow.length > 0;
  }

  isflowSLMPeriodOff(fid: string): boolean {
    const filterFlow = this.flowConfig.filter(
      item => item.flowId === fid && item.flowSLMPeriod === 'off'
    );
    return filterFlow.length > 0;
  }
}
